import { render, staticRenderFns } from "./SetPaperStepTwoFillBlank.vue?vue&type=template&id=0983d66b&scoped=true&"
import script from "./SetPaperStepTwoFillBlank.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoFillBlank.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoFillBlank.vue?vue&type=style&index=0&id=0983d66b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983d66b",
  null
  
)

export default component.exports